import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import Heading from '~ComponentsImproved/Typography/Heading';
import { Box } from '~Styles';

const Block = styled.div<{ compact: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  background-color: var(--colorBlueGray1100);
  border-radius: 8px;
  border: ${({ compact }) => (compact ? 'none' : '1px solid var(--colorBlueGray900)')};

  & > div {
    /* No horizontal padding on handheld, the rows already pad themselves */
    padding: 8px;
  }

  & > div:not(:last-child) {
    border-bottom: ${({ compact }) =>
      compact ? '1px solid var(--colorBlueGray1000)' : '1px solid var(--colorBlueGray900)'};
  }
`;

interface Props {
  /** Optional title rendered above the block, matching the size of other settings headings. */
  title?: string;
  children: ReactNode;
  /** Forwarded so the block can still be targeted/extended by emotion styled() if needed. */
  className?: string;
  /** Tighter spacing for handheld screens */
  compact?: boolean;
}

/**
 * Container for a group of settings rows. Renders an optional title above a
 * bordered block whose direct children are separated by dividers.
 */
const SettingsBlock: FC<Props> = ({ title, children, className, compact = false }) => {
  return (
    <Box display="flex" flexDirection="column" gap={compact ? 'xs' : 'small'}>
      {title && (
        <Heading level={compact ? 5 : 4} color="var(--colorWhite)">
          {title}
        </Heading>
      )}

      <Block className={className} compact={compact}>
        {children}
      </Block>
    </Box>
  );
};

export default SettingsBlock;
